import React from 'react'
import { TagStatusButtonStyled } from 'Features/domainsManagement/components/DomainManagmentRow/ConnectedButtonWithEdit/ConnectedButtonWithEditStyled.styled'
import { useTranslation } from 'react-i18next'
import { Connected } from 'Features/domainsManagement/components/DomainManagmentRow/DomainManagementRow.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faPenToSquare } from '@fortawesome/pro-thin-svg-icons'
import { Tooltip } from '@clickcease/cc-client-components-lib'
import { useUserStore } from 'Stores/userStoreModuleFed'

type TagStatusButtonProps = {
  onClick: () => void
  text: string
}

export const TagStatusButton = ({ onClick, text }: TagStatusButtonProps) => {
  const { t } = useTranslation('domainManagement')
  const { owner } = useUserStore()

  return (
    <TagStatusButtonStyled>
      <Connected>{text}</Connected>
      {owner && (
        <Tooltip tooltiptContent={t('edit_tag')}>
          <FontAwesomeIcon width={'16px'} onClick={onClick} icon={faPenToSquare as IconProp} />
        </Tooltip>
      )}
    </TagStatusButtonStyled>
  )
}
